const TOKEN_SHIFT_TIME = 15000; // 15 sec

export function isTokenExpired(
  expiresIn: number,
  safeShift: number = TOKEN_SHIFT_TIME,
) {
  const currentTime = Date.now();

  return currentTime > expiresIn * 1000 - safeShift;
}

export function isBullhornTokenExpired(
  expiresIn: string,
  safeShift: number = TOKEN_SHIFT_TIME,
) {
  const currentTime = Date.now();
  const expireTime = Date.parse(expiresIn);

  return currentTime > expireTime - safeShift;
}

export const PasswordValidationRules = {
  LowercaseCharacter: new RegExp(`[a-z]+`),
  SpecialCharacter: new RegExp(`[!"#$%&'()*+,-./:;<=>?@[\\]^_\`{|}~]+`),
  UppercaseCharacter: new RegExp(`[A-Z]+`),
  MinimumCharacters: new RegExp(`.{8,}`),
  MaximumCharacters: new RegExp(`^.{1,50}$`),
  OneNumber: new RegExp(`[0-9]+`),
};

export const obscureEmail = (email: string) => {
  const [name, domain] = email.split('@');
  const limit = name.length > 4 ? 4 : 1;
  return `${name.slice(0, limit)}${new Array(name.length - limit + 1).join(
    '*',
  )}@${domain}`;
};